import { GiftItemBrand } from '@shared/api/giftItemBrand/giftItemBrand.interface';

/**
 * 개별배송 허용 여부 판정 — 상품값이 브랜드값을 오버라이드.
 *
 * effective = giftItemInfo.allowIndividualDelivery
 *           ?? giftItemInfo.giftItemBrand.allowIndividualDelivery
 *           ?? true
 *
 * 둘 다 미설정이면 허용(true). 최종이 false면 일괄배송(Bulk) 전용.
 */
export const resolveAllowIndividualDelivery = (
  giftItemInfo?: {
    allowIndividualDelivery?: boolean;
    giftItemBrand?: GiftItemBrand | string;
  } | null,
): boolean => {
  if (!giftItemInfo) return true;

  if (typeof giftItemInfo.allowIndividualDelivery === 'boolean') {
    return giftItemInfo.allowIndividualDelivery;
  }

  const brand = giftItemInfo.giftItemBrand;
  if (
    brand &&
    typeof brand === 'object' &&
    typeof brand.allowIndividualDelivery === 'boolean'
  ) {
    return brand.allowIndividualDelivery;
  }

  return true;
};
